import React, { createContext, useState, useContext } from 'react';

const GlobalSpinnerContext = createContext();
const GlobalSpinnerActionsContext = createContext();

export const useGlobalSpinnerContext = () => useContext(GlobalSpinnerContext);
export const useGlobalSpinnerActionsContext = () =>
  useContext(GlobalSpinnerActionsContext);

export function GlobalSpinnerContextProvider({ children }) {
  const [isSpinnerOn, setGlobalSpinner] = useState(false);

  // const UpdateGlobalSpinnerStatus = (status) => {
  //   setGlobalSpinner(status);
  // };

  return (
    <GlobalSpinnerContext.Provider value={isSpinnerOn}>
      <GlobalSpinnerActionsContext.Provider value={setGlobalSpinner}>
        {children}
      </GlobalSpinnerActionsContext.Provider>
    </GlobalSpinnerContext.Provider>
  );
}
